<template>
  <el-button style="margin-bottom: 15px; float: left;" type="primary" @click='dialogFormVisible = true'>{{ $t('kbType.newKbType', { msg: 'kbType.newKbType' }) }}</el-button>
  <el-table
    tooltip-effect="dark"
    border
    stripe
    highlight-current-row
    :data="tableData"
    style="width: 100%"
    :row-class-name="tableRowClassName"
    :header-cell-style="{background:'#eef1f6',color:'#606266'}">
    <el-table-column prop="typeParentName" :label="$t('kbType.typeParentName', { msg: 'kbType.typeParentName' })">
    </el-table-column>
    <el-table-column prop="type" :label="$t('kbType.kbType', { msg: 'kbType.kbType' })">
    </el-table-column>
    <el-table-column prop="createBy" :label="$t('kbType.creator', { msg: 'kbType.creator' })">
    </el-table-column>
    <el-table-column  :label="$t('kbType.tag', { msg: 'kbType.tag' })" width="280">
      <template #default="scope">
      <el-tag
      v-for="tag in scope.row.tag"
      :key="tag.id"
      :closable="isAdmin"
      @close="handleClose(tag.id)"
      effect="dark"
      size="mini"
      :type="getRandomColor()">
        {{tag.tag}}
     </el-tag>
     </template>
    </el-table-column>
    <el-table-column prop="createTime" :label="$t('kbType.createTime', { msg: 'kbType.createTime' })">
    </el-table-column>
    <el-table-column :label="$t('kbReview.table.opr', { msg: 'kbReview.table.opr' })" width="320" v-if="isAdmin">
            <template #default="scope">
               
              <el-button
                    size="mini"
                    type="success" 
                    icon="el-icon-zoom-in"
                    @click="handleTag(scope.$index, scope.row)">{{  $t('kbType.addTag', { msg: 'kbType.addTag' }) }}</el-button>
                <el-button
                    size="mini"
                    type="primary" 
                    icon="el-icon-edit"
                    @click="handleEdit(scope.$index, scope.row)">{{  $t('kbType.update', { msg: 'kbType.update' }) }}</el-button>
                <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row.id)">{{ $t('kbReview.delete', { msg: 'kbReview.delete' }) }}</el-button>
            
            </template>
            </el-table-column>
  </el-table>
  <div class="pagination-tools">
    <el-pagination
      background
      layout="sizes, prev, pager, next, jumper, ->, total"
      :page-size="pageParam.pageSize"
      :current-page="pageParam.pageNum"
      :page-sizes="pageSizes"
      :total="total"
      :hide-on-single-page="false"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange">
    </el-pagination>
  </div>
  <el-dialog :title="$t('kbType.mKbType', { msg: 'mKbType.kbType' })" 
    v-model="dialogFormVisible"
    width="40%"
    :before-close="typeDialogClose">
    <el-form ref="form" :model="form" label-width="160px" :rules="rules">
      <el-form-item :label="$t('kbType.typeParentName', { msg: 'kbType.typeParentName' })" prop="typeParentName">
        <el-select
          style="width: 100%"
          v-model="form.typeParentName"
          filterable
          allow-create
          default-first-option
          :placeholder="$t('kbType.parentTips', { msg: 'kbType.parentTips' })">
          <el-option
            v-for="item in parentData"
            :key="item.id"
            :label="item.typeParentName"
            :value="item.typeParentName">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('kbType.kbType', { msg: 'kbType.kbType' })" prop="type">
        <el-input v-model="form.type" :placeholder="$t('kbType.kbTypeD', { msg: 'kbType.kbTypeD' })"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addKType('form')">{{ $t('kbType.newKbType', { msg: 'kbType.newKbType' }) }}</el-button>
        <el-button @click="dialogFormVisible = false">{{ $t('kbType.cancel', { msg: 'kbType.cancel' }) }}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
  <!-- 修改类型 -->
  <el-dialog :title="$t('kbType.editKBType', { msg: 'kbType。editKBType' })" v-model="dialogFormEditor" width="40%">
  <el-form ref="formType" :model="formType" :rules="rulesType" label-width="160px">
    <el-form-item :label="$t('kbType.typeParentName', { msg: 'kbType.typeParentName' })"  prop="parentId">
      <el-select style="width: 100%" v-model="formType.parentId" :placeholder="$t('kbType.parentTip', { msg: 'kbType.parentTip' })">
        <el-option
            v-for="item in parentData"
            :key="item.id"
            :label="item.typeParentName"
            :value="item.id">
          </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('kbType.kbType', { msg: 'kbType.kbType' })"  prop="type">
      <el-input v-model="formType.type" autocomplete="off"></el-input>
    </el-form-item>   
  </el-form>
  <div>
    <el-button type="primary" @click="editKBType('formType')">{{  $t('kbType.update', { msg: 'kbType.update' }) }}</el-button>
    <el-button @click="dialogFormEditor = false">{{  $t('valueChain.cancel', { msg: 'valueChain.cancel' }) }} </el-button>
  </div>
</el-dialog>
<!-- 添加标签 -->
<el-dialog :title="$t('kbType.addTag', { msg: 'kbType.addTag' })" v-model="dialogTagAdd" width="40%">
  <el-form ref="formTag" :model="formTag" >
    <el-form-item :label="$t('kbType.kbType', { msg: 'kbType.kbType' })" label-width="100px">
      <el-input v-model="formType.type" :disabled="true" class="my-custom-input"></el-input>
    </el-form-item>
    <el-form-item :label="$t('kbType.tag', { msg: 'kbType.tag' })" label-width="100px">
      <el-input v-model="formTag.tag" class="my-custom-input"></el-input>
    </el-form-item>
  </el-form>
  <div> 
    <el-button type="primary" @click=" tagAdd('formTag')">{{  $t('kbType.addTag', { msg: 'kbType.addTag' }) }}</el-button>
    <el-button @click="dialogTagAdd = false">{{  $t('valueChain.cancel', { msg: 'valueChain.cancel' }) }}</el-button>
  </div>
</el-dialog>

</template>

<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }

  .my-custom-input .el-input__inner {
    font-weight: bold; /* 设置字体加粗 */
    font-size: 18px;
}
</style>

<script>
import { baseUrl_New } from '../../axios/urlconfig';
import { deleteRequest, getRequest, postRequest } from '../../axios/axios';

export default {
  data() {
    return {
      rules: {
        typeParentName: [
          { required: true, message: this.$t('kbType.TypeParentTips', { msg: 'KbType.TypeParentTips' }), trigger: 'blur' },
          { min: 1, max: 15, message: this.$t('kbType.lengthD15', { msg: 'mKbType.lenghtD15' }), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('kbType.kbTypeD', { msg: 'KbType.kbTypeD' }), trigger: 'blur' },
          { min: 1, max: 15, message: this.$t('kbType.lengthD15', { msg: 'mKbType.lenghtD15' }), trigger: 'blur' }
        ]
      },
      tableData: [
      {
            "id": '',
            "type": '',
            "createBy": "",
            "parentId": '',
            "typeParentName": '',
            "tag": [
                {
                    "id": '',
                    "tag": '',
                    "kbTypeId": '',
                    "createTime": '',
                    "upDateTime": ''
                }
            ],
            "createTime": ''
        }
      ],
      dialogFormVisible: false,
      dialogTagAdd: false,
      dialogTagTable: false,
      tags: [],
      tagColor:['success','info','warning','danger',''],
      formTag:{
        tag:'',
        KBTypeId:''
      },
      pageParam: { //分页参数
        pageNum: 1, //当前页
        pageSize: 10 //每页条目数据
      },
      total: 0, //总条目数
      pageSizes: [10, 20, 30, 40], //每页显示条目数列表
      form: {
        typeParentName: '',
        type: ''
      },
      parentData: [],
      loginName: '',
      dialogFormEditor:false,
      formType:{
        id:'',
        type:'',
        parentId:'',
      },
      isAdmin:sessionStorage.role.includes('超级管理员'),
      rulesType:{
        type: [
            { required: true, message:this.$t('kbinfo.kbTypeD', { msg: 'kbinfo.kbTypeD' }), trigger: 'blur' }
          ],
        parentId: [
            { required: true, message:this.$t('kbType.parentTip', { msg: 'kbType.parentTip' }), trigger: 'change' }
          ],
      }

    }
  },

  created() {
    this.getAllList();
    this.getParent();
    this.getLoginUserName();
    this.getRandomColor();
  },

  methods: {
    // tableRowClassName({ row, rowIndex }) {
    //   if (rowIndex % 4 === 1) {
    //     return 'warning-row';
    //   } else if (rowIndex % 4 === 3) {
    //     return 'success-row';
    //   }
    //   return '';
    // },

    typeDialogClose() { //关闭新增对话框
      this.dialogFormVisible = false;
    },

    addKType(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          postRequest(baseUrl_New + '/kType/insert', {
            typeParentName: this.form.typeParentName,
            type: this.form.type,
            createBy: this.loginName
          }).then(resp => {
            this.typeDialogClose();
            this.getAllList();
            this.getParent();
            this.form = {}; //清空form输入框
            this.$message.success(this.$t('kbType.newKbS', { msg: 'mKbType.newKbS' }));
          }).catch(err => {
            this.$message.error(this.$t('kbType.newKbF', { msg: 'mKbType.newKbF' }));
          })
        } else {
          return false;
        }
      });
    },

    handleSizeChange(val) {
      this.pageParam.pageSize = val;
      this.getAllList();
    },

    handleCurrentChange(val) {
      this.pageParam.pageNum = val;
      this.getAllList();
    },

    //获取所有的知识类别
    getAllList() {
      getRequest(baseUrl_New + '/kType/getPage/' + this.pageParam.pageNum + '/' + this.pageParam.pageSize).then(response => {
        //获得服务器端回传的map对象
        let resultMap = response;
        //从集合中获取用户列表及总条目数
        this.tableData = resultMap.list;
        this.total = resultMap.total;
      });
    },

    getParent() {
      getRequest(baseUrl_New + '/kType/getParent').then(response => {
        //获得服务器端回传的map对象
        let resultMap = response;
        //从集合中获取用户列表及总条目数
        this.parentData = resultMap.data.list;
      });
    },

    getLoginUserName() {
      this.loginName = sessionStorage.getItem("name");
    },
    handleEdit(index, row){
        this.dialogFormEditor=true;
        this.formType = JSON.parse(JSON.stringify(row));
       },
    handleTag(index, row){
        this.dialogTagAdd=true;
        this.formType = JSON.parse(JSON.stringify(row));
       },
    openTag(index, row){
        this.dialogTagTable=true;
        this.formType = JSON.parse(JSON.stringify(row));
        this.queryTagById(row.id);
    },
    editKBType(formName){
          this.$refs[formName].validate((valid) => {
          if (valid) {
            var that = this
        postRequest(baseUrl_New + '/kType/update',{
          id:this.formType.id,
          type:this.formType.type,
          parentId:this.formType.parentId,
        
        }).then(resp=>{
          this.getAllList(); 
          this.dialogFormEditor=false;
          this.formType={};
          this.$message.success("更新成功");
        }).catch(err => {
          this.$message.error("更新失败")
        })
          } else {
            
            return false;
          }
        });
            
        },
        handleDelete(index, id){
        this.$confirm( this.$t('kbReview.deleteD', { msg: 'kbReview.deleteD' }), this.$t('issue.tips', { msg: 'issue.tips' }),{
            confirmButtonText: this.$t('addType.confirm', { msg: 'addType.comfirm' }),
            cancelButtonText: this.$t('addType.cancel', { msg: 'addType.cancel' }),
            cancelButtonClass: 'btn-custom-cancel',
            type: 'warning'
        }).then(() => {
            deleteRequest(baseUrl_New + `/kType/del/${id}`)
            .then(response=>{
            // console.log(response);
            //this.$message.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }))
            if (response.code == 0) {
                    this.$message.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }));
                } else if (response.code == 1) {
                    this.$message.error(response.message);
                }
            this.getAllList();
                                 
            })
        })
        },
        tagAdd(formName){
          postRequest(baseUrl_New + '/kType/add', {
            tag:this.formTag.tag,
            kbTypeId:this.formType.id,
          }).then(resp => {
            this.getAllList();
            this.dialogTagAdd = false;
            this.formTag = {};
          }).catch(err => {
            this.$message.error("添加标签错误！");
          })
        },
        queryTagById(id) {
        getRequest(baseUrl_New + '/kType/tag?id='+id).then(response => {
        //获得服务器端回传的map对象
        let resultMap = response;
        //从集合中获取用户列表及总条目数
        this.tags = resultMap.data.list;
      });
        },
        getRandomColor(){
          // 获取数组长度
        const arrayLength = this.tagColor.length;
         // 生成一个随机索引
        const randomIndex = Math.floor(Math.random() * arrayLength);
         // 返回随机索引对应的值
       return this.tagColor[randomIndex];
       },
       handleClose(id){
        this.$confirm( this.$t('kbReview.deleteTag', { msg: 'kbReview.deleteTag' }), this.$t('issue.tips', { msg: 'issue.tips' }),{
            confirmButtonText: this.$t('addType.confirm', { msg: 'addType.comfirm' }),
            cancelButtonText: this.$t('addType.cancel', { msg: 'addType.cancel' }),
            cancelButtonClass: 'btn-custom-cancel',
            type: 'warning'
        }).then(() => {
            deleteRequest(baseUrl_New + `/kType/remove/${id}`)
            .then(response=>{
            // console.log(response);
            this.$message.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }))
            this.getAllList();
                                 
            })
        })
       },


  }
}
</script>
